import React from 'react';
import ClientServicesList from '../client/ClientServicesList';
import SimpleInput from '../form/SimpleInput';
import SVGChevron from '../../svg/Chevron';
import { maskWeeklyServiceBlock, maskCapitalizeFirstLetter } from '../../masks';

class ClientServices extends React.Component {
  state = {
    isPastOpen: false,
    isPromoOpen: false
  };

  render() {
    return (
      <div className="cms__section client-services">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Services</h3>
          </div>
        </div>
        <div className="cms__section-body">
          <div className="client-services__settings">
            <div className="row">
              {this.renderWeeklyService()}
              {this.renderPromoCode()}
            </div>
          </div>
          <div className="client-services__services">
            {this.renderUpcomingServices()}
            {this.renderPastServices()}
            {this.renderPastServicesToggle()}
          </div>
        </div>
      </div>
    );
  }

  renderUpcomingServices() {
    return (
      <div className="client-services__upcoming">
        <div className="header-row">
          <h4 className="h4">Upcoming</h4>
          {this.renderPausedStatus()}
        </div>
        <ClientServicesList
          client={this.props.client}
          filter="future"
          perPage={10}
          columns={this.props.columns}
        />
      </div>
    );
  }

  renderPastServices() {
    if (!this.state.isPastOpen) return '';

    // Remove Select Menu Column
    const columns = this.props.columns.filter(
      item => !item.link || item.link.label !== 'Select Menu'
    );
    return (
      <div className="client-services__past">
        <h4 className="h4">Past:</h4>
        <ClientServicesList
          client={this.props.client}
          filter="past_all"
          columns={columns}
        />
      </div>
    );
  }

  renderPastServicesToggle() {
    return this.state.isPastOpen ? (
      <div
        className="a--blue a--center"
        onClick={() => this.setState({ isPastOpen: false })}
      >
        Collapse Past Services{' '}
        <span className="chev">
          <SVGChevron className="svg--flip-v" />
        </span>
      </div>
    ) : (
      <div
        className="a--blue a--center"
        onClick={() => this.setState({ isPastOpen: true })}
      >
        View Past Services{' '}
        <span className="chev">
          <SVGChevron />
        </span>
      </div>
    );
  }

  renderWeeklyService() {
    const {
      client_service_preferences,
      menu_selection_status
    } = this.props.client;
    const blocks = !client_service_preferences
      ? []
      : client_service_preferences.map((pref, key) => {
          return (
            <p className="p" key={key}>
              {this.maskDayOfWeek(pref.day_of_week)},{' '}
              {maskWeeklyServiceBlock(pref.start_time)}
            </p>
          );
        });
    const serviceTypeSelection = (
      <p className="p p--dark-taupe">
        {this.props.menuSelectionSwitch(menu_selection_status)}
      </p>
    );
    return (
      <div className="row__item row__item--half">
        <p className="p p--bold client-services__heading">
          Weekly Service Settings{' '}
          <span
            className="a--blue a--inline"
            onClick={this.props.openSettingsModal}
          >
            Edit
          </span>
        </p>
        {blocks}
        {serviceTypeSelection}
      </div>
    );
  }

  renderPromoCode() {
    const { code = '' } = this.props.client;
    return (
      <div className="row__item row__item--half">
        <p className="p p--bold client-services__heading">
          Code {this.renderEditPromoToggle()}
        </p>
        {!code && !this.state.isPromoOpen ? (
          <p className="a--blue" onClick={this.togglePromoCode}>
            +Add
          </p>
        ) : (
          ''
        )}
        {this.state.isPromoOpen ? (
          <SimpleInput
            type="text"
            name="code"
            value={code}
            onChange={this.handleChange}
          />
        ) : (
          <p className="p">{code}</p>
        )}
      </div>
    );
  }

  renderEditPromoToggle() {
    if (!this.props.client.code && !this.state.isPromoOpen) return '';
    return this.state.isPromoOpen ? (
      <span className="a--blue a--inline" onClick={this.togglePromoCode}>
        Save
      </span>
    ) : (
      <span className="a--blue a--inline" onClick={this.togglePromoCode}>
        Edit
      </span>
    );
  }

  renderPausedStatus() {
    let today, startDate, status;
    if (this.props.client.pause_start_date !== null) {
      today = new Date();
      startDate = new Date(this.props.client.pause_start_date);
      status = startDate <= today ? 'Paused' : 'Active';
    } else {
      status = 'Active';
    }
    return <h4 className="h4 pause-status">Status: {status}</h4>;
  }

  maskDayOfWeek = day => {
    return `${maskCapitalizeFirstLetter(day)}s`;
  };

  togglePromoCode = () =>
    this.setState({ isPromoOpen: !this.state.isPromoOpen });

  handleChange = e => {
    this.props.updateClient({ [e.target.name]: e.target.value });
  };
}

export default ClientServices;



// WEBPACK FOOTER //
// ./src/components/client/ClientServices.js